<script>
import { cloneObject } from '../../helpers/common';

export default {
    props: {
        source: {
            type: Object
        }
    },
    render() {
        this.source.$on('updated', this.sourceUpdated);

        return this.cloneVnode(this.source.$vnode);
    },
    methods: {
        sourceUpdated() {
            let sourceVnode = this.source.$vnode;
            let target = this.$children[0];

            if(sourceVnode.componentInstance) {
                let scopedSlots = sourceVnode.componentInstance.$scopedSlots || null;

                if(scopedSlots) {
                    this.copyScopedSlots(scopedSlots, target.$scopedSlots);
                }
            }
        },
        cloneVnode(sourceVnode) {
            let tag = sourceVnode.tag,
                childData = {};
            
            if(sourceVnode.componentOptions) {
                tag = sourceVnode.componentOptions.tag;
                childData.props = cloneObject(sourceVnode.componentOptions.propsData);
            }
            if(sourceVnode.componentInstance) {
                let scopedSlots = sourceVnode.componentInstance.$scopedSlots || null;
                if(scopedSlots) {
                    childData.scopedSlots = {};
                    this.copyScopedSlots(scopedSlots, childData.scopedSlots);
                }
            }
            if(sourceVnode.data) {
                childData.attrs = sourceVnode.data.attrs || {};
                childData.staticClass = sourceVnode.data.staticClass || '';

                if('slot' in sourceVnode.data) {
                    childData.slot = sourceVnode.data.slot;
                }
            }
            if(sourceVnode.key) {
                childData.key = sourceVnode.key;
            }

            if(!tag) {
                return sourceVnode.text;
            } else {
                return this.source.$createElement(
                    tag,
                    childData,
                    (this.createChildrenRecursive(sourceVnode) || sourceVnode.text)
                );
            }
        },
        createChildrenRecursive(sourceVnode) {
            let children = [];
            let sourceChildren = sourceVnode.children;

            if(sourceVnode.componentOptions) {
                sourceChildren = sourceVnode.componentOptions.children;
            }

            if(!sourceChildren) {
                return false;
            }

            sourceChildren.forEach(sourceChild => {
                children.push(this.cloneVnode(sourceChild))
            });

            return children;
        },
        copyScopedSlots(slots, target) {
            Object.keys(slots).forEach(key => {
                let slot = slots[key];

                if(typeof slot == 'function') {
                    target[key] = slot;
                }
            });
        }
    }
}
</script>